export enum INTEGRATION_CODES {
  MERCEDES_XENTRY = 'MERCEDES_XENTRY_JOB',
  MERCEDES_CLARA = 'DAIMLER_CLARA',
  MERCEDES_DAIMLER_XENTRY = 'DAIMLER_XENTRY_JOB',
  OTHER_SAG = 'SAG',
  OTHER_TECRMI = 'TECRMI',
  OTHER_INTERCARS = 'INTERCARS_CZ',
  MAZDA_PORTAL = 'MAZDA_PORTAL',
}
